export default "__VITE_PUBLIC_ASSET__2100bc48__"